import { render, staticRenderFns } from "./PurDL.vue?vue&type=template&id=3405575a"
import script from "./PurDL.vue?vue&type=script&lang=js"
export * from "./PurDL.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports